var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 27,
    viewBox: "0 0 61 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 72 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.02979 19V4.45456H4.22439V10.7756H11.4758V4.45456H13.6775V19H11.4758V12.6577H4.22439V19H2.02979ZM32.582 19V8.09092H34.6203V9.86649H34.7552C34.9825 9.26516 35.3542 8.79641 35.8703 8.46024C36.3864 8.11933 37.0043 7.94887 37.724 7.94887C38.4532 7.94887 39.064 8.11933 39.5564 8.46024C40.0535 8.80115 40.4205 9.2699 40.6572 9.86649H40.7709C41.0313 9.2841 41.4456 8.82009 42.0138 8.47444C42.582 8.12406 43.259 7.94887 44.045 7.94887C45.0346 7.94887 45.8419 8.25901 46.4669 8.87927C47.0966 9.49954 47.4115 10.4347 47.4115 11.6847V19H45.2879V11.8835C45.2879 11.1449 45.0867 10.6098 44.6842 10.2784C44.2818 9.94698 43.8012 9.78126 43.2425 9.78126C42.5512 9.78126 42.0138 9.99433 41.6302 10.4205C41.2467 10.8419 41.055 11.384 41.055 12.0469V19H38.9385V11.7486C38.9385 11.1567 38.7538 10.6809 38.3845 10.321C38.0152 9.96118 37.5346 9.78126 36.9427 9.78126C36.5403 9.78126 36.1686 9.88779 35.8277 10.1009C35.4915 10.3092 35.2193 10.6004 35.0109 10.9744C34.8073 11.3485 34.7055 11.7817 34.7055 12.2741V19H32.582ZM54.9594 19.2202C53.8846 19.2202 52.959 18.9905 52.1825 18.5312C51.4107 18.0672 50.8141 17.4162 50.3927 16.5781C49.976 15.7353 49.7677 14.7481 49.7677 13.6165C49.7677 12.4991 49.976 11.5142 50.3927 10.6619C50.8141 9.80967 51.4012 9.14442 52.154 8.6662C52.9116 8.18798 53.797 7.94887 54.8103 7.94887C55.4258 7.94887 56.0224 8.05067 56.6001 8.25427C57.1777 8.45787 57.6962 8.77747 58.1555 9.21308C58.6147 9.64868 58.977 10.2145 59.2421 10.9105C59.5073 11.6018 59.6398 12.4422 59.6398 13.4318V14.1847H50.968V12.5938H57.5589C57.5589 12.035 57.4452 11.5402 57.218 11.1094C56.9907 10.6738 56.6711 10.3305 56.2592 10.0795C55.852 9.82861 55.3737 9.70313 54.8245 9.70313C54.2279 9.70313 53.7071 9.84992 53.262 10.1435C52.8217 10.4323 52.4807 10.8111 52.2393 11.2798C52.0025 11.7438 51.8842 12.2481 51.8842 12.7926V14.0355C51.8842 14.7647 52.012 15.3849 52.2677 15.8963C52.5281 16.4077 52.8903 16.7983 53.3543 17.0682C53.8183 17.3333 54.3605 17.4659 54.9807 17.4659C55.3832 17.4659 55.7502 17.4091 56.0816 17.2955C56.413 17.1771 56.6995 17.0019 56.941 16.7699C57.1825 16.5379 57.3671 16.2514 57.495 15.9105L59.5049 16.2727C59.3439 16.8646 59.0551 17.383 58.6384 17.8281C58.2265 18.2685 57.708 18.6117 57.083 18.858C56.4628 19.0994 55.7549 19.2202 54.9594 19.2202Z",
    fill: "#F0F1F9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    filter: "url(#filter0_d_49_2228)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.0397 10.7908C17.8953 9.22068 18.4689 7.63912 19.45 6.44716C20.4334 5.25248 21.7815 4.5 23.1434 4.5C24.5045 4.5 25.842 5.25084 26.8204 6.44494C27.7967 7.63654 28.3722 9.22065 28.2465 10.7969C28.1775 11.662 27.6668 12.3132 27.0571 13.0284C27.0324 13.0573 27.0074 13.0865 26.9823 13.1159C26.7117 13.4325 26.4209 13.7726 26.1974 14.1286C26.0296 14.3958 25.8878 14.6894 25.8128 15.0143H20.7435C20.6393 14.7059 20.4678 14.4271 20.281 14.176C20.0587 13.877 19.7818 13.5764 19.5161 13.2878C19.4559 13.2226 19.3964 13.1579 19.3382 13.094C18.6736 12.3648 18.1202 11.6667 18.0397 10.7908Z",
    stroke: "#F0F1F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M23.2992 18.9375C24.9319 18.9375 26.2555 17.4049 26.2555 15.5143H20.3428C20.3428 17.4049 21.6664 18.9375 23.2992 18.9375Z",
    fill: "#F0F1F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M23.2988 9.44595V15.3587",
    stroke: "#F0F1F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M23.2992 9.10157C23.6246 9.10157 23.8883 8.83778 23.8883 8.51238C23.8883 8.18698 23.6246 7.92319 23.2992 7.92319C22.9738 7.92319 22.71 8.18698 22.71 8.51238C22.71 8.83778 22.9738 9.10157 23.2992 9.10157Z",
    stroke: "#F0F1F9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_49_2228",
    x: 13.5176,
    y: 4,
    width: 19.2461,
    height: 22.9375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.270588 0 0 0 0 0.482353 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_49_2228"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_49_2228",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home_icon.34d75cfef0d7453ca17b9a3c9e9efd63.svg";
export { ForwardRef as ReactComponent };